var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"language",on:{"click":_vm.toggleLanguage}},[_c('svg-icon',{attrs:{"icon-name":"language"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }